export const DOM_READY = 'domready';
export const RIGHT_CLICK = 'rightclick';
export const LEFT_CLICK = 'click';
